import { makeStyles, Theme } from "@material-ui/core/styles";

const styles = makeStyles((theme: Theme) => ({
  tableFlex: {
    display: 'flex',
    flexDirection: 'column'
  },
  cells: {
    display: 'flex',
    alignItems: 'center',
  },
  noResults: {
    justifyContent: 'center',
  },
  icons: {
    position: 'relative',
    marginRight: 4,
  },
  columnWidthCheckboxes: {
    width: '80px',
  },
  borderBottom: {
    borderBottom: 'none',
  },
  availabilityFilterLabel: {
    textTransform: 'none',
  },
  availabilityButton: {
    cursor: 'text',
    fontSize: 16,
    color: theme.palette.constrastGreyDark.main,
    height: 40,
    float: 'left',
    marginTop: 10,
    marginBottom: 10,
  },
  divFilters: {
    display: 'flex',
    justifyContent: 'flex-end',
    '& > button': {
      marginRight: 50,
    },
    '& > div': {
      marginRight: 50,
    },
  },
  divGroups: {
    marginLeft: '27px',
  },
  divItems: {
    marginLeft: '80px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  divItemsSmallScreen: {
    marginLeft: '50px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width:600,
  },
  divCellText:{
    width:900,
  },
  divCellIconDetails:{
    width:40,
    marginLeft: '40px',
  },
  divCellTextSmallScreen:{
    width:600,
  },
  divCellIconDetailsSmallScreen:{
    width:40,
    marginLeft: '10px',
  },
}));

export default styles;
